import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  Box,
  CircularProgress,
  Grid,
  Pagination,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  convertArrayToStringWithCount,
  customTextColor,
} from "../../utils/const";
import {
  getFilterCandidateForRequirement,
  getPostRequirement,
  sendjobToCandidate,
} from "../../redux/post-requirement/postRequirementSlice";
import CandidateCardForJobPost from "../../components/containers/CandidateCardForJobPost";
import SelectedcandidateViewDrawer from "./SelectedcandidateViewDrawer";
import InfiniteScroll from "react-infinite-scroll-component";

const SendRequirementToCandidateDrawer = ({
  handleClose,
  show,
  handleCloseFirstDrawer,
  jobID,
}) => {
  const dispatch = useDispatch();
  const [candidates, setCandidates] = useState([]);
  const [hasNext, setHasNext] = useState(false);
  const postRequirement = useSelector((state) => state.postrequirement);
  const locations = useSelector((state) => state.location);
  const skillData = useSelector((state) => state.skill.data);
  const [showSelected, setShowSelected] = useState(false);
  const handleCloseShowSelected = () => setShowSelected(false);
  const handleShowSelected = () => setShowSelected(true);
  const requirementLoading = useSelector(
    (state) => state.postrequirement.status
  );

  const filterCandidate = useSelector(
    (state) => state.postrequirement.filterCandidate
  );

  useEffect(() => {
    if (jobID && Object.keys(jobID).length > 0) {
      setPages(1);
      setCandidates([]);
      fetchCandidates(1);
    }
  }, [jobID]);

  const [page, setPages] = useState(filterCandidate?.current_page || 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    has_next: false,
    has_previous: false,
    next_page: null,
    previous_page: null,
    total_pages: 1,
  });

  useEffect(() => {
    if (jobID && Object.keys(jobID).length > 0) {
      let job_ID = jobID?.job_id;
      const query = `page=1`;
      dispatch(getFilterCandidateForRequirement({ job_ID, query }));
    }
  }, [jobID]);

  useEffect(() => {
    if (filterCandidate) {
      setPagination({
        current_page: filterCandidate?.current_page,
        has_next: filterCandidate?.has_next,
        has_previous: filterCandidate?.has_previous,
        next_page: filterCandidate?.next_page,
        previous_page: filterCandidate?.previous_page,
        total_pages: filterCandidate?.total_pages,
      });
    }
  }, [filterCandidate]);

  const handlePageChange = (event, value) => {
    setPages(value);
  };

  const getPreferSkillsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          skillData?.locations?.find((location) => location.id === id)?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getPreferLocationsNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const getPreferLocationNames = (preferLocation) => {
    const names =
      preferLocation
        ?.map(
          (id) =>
            locations?.data?.locations?.find((location) => location.id === id)
              ?.name
        )
        ?.filter(Boolean) || []; // Remove undefined & fallback to empty array

    if (names.length <= 2) {
      return names.join(", "); // If 2 or fewer names, show them directly
    }

    const firstTwo = names.slice(0, 2).join(", ");
    const remainingCount = names.length - 2;

    return `${firstTwo} + ${remainingCount}`;
  };

  useEffect(() => {
    if (filterCandidate) {
      setCandidates(filterCandidate?.results);
    }
  }, [filterCandidate]);

  const toggleSelect = (id) => {
    const updateCandidate = candidates?.map((candidate) =>
      candidate?.candidate_details?.id === id
        ? { ...candidate, selected: !candidate.selected }
        : candidate
    );
    setCandidates(updateCandidate);
  };

  let selectedCandidate = candidates?.filter((res) => res?.selected === true);

  let selectedCandidateID = selectedCandidate?.map(
    (res) => res?.candidate_details?.id
  );

  useEffect(() => {
    if (selectedCandidate?.length > 0) {
      handleShowSelected();
    } else {
      handleCloseShowSelected();
    }
  }, [selectedCandidate]);

  const handleOnSendJob = () => {
    let bodyData = {
      candidate_resume_ids: selectedCandidateID,
      job_id: jobID?.job_id,
    };
    dispatch(sendjobToCandidate(bodyData));
  };

  useEffect(() => {
    if (requirementLoading === "send_job_candidate_success") {
      dispatch(getPostRequirement(""));
      handleClose();
      handleCloseFirstDrawer();
    }
  }, [requirementLoading]);

  const fetchCandidates = (pageNumber = 1) => {
    const query = `page=${pageNumber}`;
    let job_ID = jobID?.job_id;

    dispatch(getFilterCandidateForRequirement({ job_ID, query })).then(
      (res) => {
        if (res.payload?.profiles) {
          setCandidates((prev) =>
            pageNumber === 1
              ? res.payload.profiles
              : [...prev, ...res.payload.profiles]
          );
          setHasNext(res.payload.has_next);
        }
      }
    );
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "65%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography>
          <b>Here are top matching candidates for this job.</b>
        </Typography>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Box>
          {requirementLoading === "loading" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 230,
              }}
            >
              <CircularProgress size={30} color="info" />
            </Box>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                // sx={{ padding: "15px 0 0 0" }}
              >
                {candidates?.length > 0 ? (
                  <InfiniteScroll
                    dataLength={candidates.length}
                    next={() => {
                      if (hasNext) {
                        const nextPage = page + 1;
                        setPages(nextPage);
                        fetchCandidates(nextPage);
                      }
                    }}
                    hasMore={hasNext}
                    loader={
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: 30,
                          marginTop: "20px",
                        }}
                      >
                        <CircularProgress size={30} color="info" />
                      </Box>
                    }
                    scrollableTarget="offcanvasScroll"
                    scrollThreshold={0.9}
                  >
                    {candidates?.map((requirement, index) => {
                      return (
                        <CandidateCardForJobPost
                          key={index}
                          name={requirement?.candidate_details?.full_name}
                          // designation={requirement?.candidate_details?.full_name}
                          job_title={
                            requirement?.candidate_details?.current_job_title
                          }
                          experience={
                            requirement?.candidate_details?.total_experience
                          }
                          location={getPreferLocationNames(
                            requirement?.candidate_details?.prefer_location
                          )}
                          prefr_tax_team={convertArrayToStringWithCount(
                            requirement?.candidate_details?.p_tax_team
                          )}
                          created_date={
                            requirement?.candidate_details?.created_at
                          }
                          res={requirement?.candidate_details}
                          toggleSelect={toggleSelect}
                          requirement={requirement}
                        />
                      );
                    })}
                  </InfiniteScroll>
                ) : (
                  <h6 style={{ textAlign: "center" }}>No Requirement Found</h6>
                  // <CandidateCardForJobPost />
                )}
              </Grid>
              {/* <Box
                sx={{
                  textAlign: "right",
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <Pagination
                  count={pagination.total_pages}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Box> */}
            </>
          )}
        </Box>
      </Offcanvas.Body>
      <SelectedcandidateViewDrawer
        handleShow={handleShowSelected}
        handleClose={handleCloseShowSelected}
        show={showSelected}
        selectedCandidate={selectedCandidate}
        handleOnSendJob={handleOnSendJob}
      />
    </Offcanvas>
  );
};

export default SendRequirementToCandidateDrawer;
